import React, {Fragment} from 'react';

import HeaderUno from '../Compartidos/HeaderUno';
import HeaderMetodos from '../../AuxiliaresPaginas/HeaderMetodos';

import { LinksVarios, Flex } from '../../Css/StyledMatematica'
import { HrMetodos } from '../../Css/StyledHeader';

const Calculo = () => {
    

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"matematica/"} n1={"Métodos"} n2={"MATEMATICA"} componente={"CALCULO"} paciente={true} bgcolor="#23AAAF" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>
            <Flex wrap='wrap'>
                <LinksVarios bgcolor='#23AAAF' color='#FFFFFF' fw='600' to={'/escritorio/metodos/matematica/calculo/suma'}>SUMA</LinksVarios>
                <LinksVarios bgcolor='#23AAAF' color='#FFFFFF' fw='600' to={'/escritorio/metodos/matematica/calculo/resta'}>RESTA</LinksVarios>
                <LinksVarios bgcolor='#23AAAF' color='#FFFFFF' fw='600' to={'/escritorio/metodos/matematica/calculo/multiplicacion'}>MULTIPLICACION</LinksVarios>
                <LinksVarios bgcolor='#23AAAF' color='#FFFFFF' fw='600' to={'/escritorio/metodos/matematica/calculo/division'}>DIVISION</LinksVarios>
            </Flex>
        </Fragment>
    );
}
 
export default Calculo;